import Vue from 'vue'
import Router from 'vue-router'
import BusinessRouts from '../router/business'
import AdminRouts from '../router/admin'

const AdminHome = () => import('@/components/admin/user/Listing')
const BusinessHome = () => import('@/components/business/Family')

Vue.use(Router)
let routeInterceptor = new Router({
  mode: 'history',
  routes: AdminRouts.concat(BusinessRouts, [
    {
      path: '/',
      name: 'home',
      meta: (route) => ({title: 'Home'}),
      components: {
        admin: AdminHome,
        business: BusinessHome
      }
    }
  ])
})

routeInterceptor.afterEach((toRoute, fromRoute) => {
  // window.document.title = 'Buy1Give1 | ' + toRoute.name.toUpperCase()
  window.document.title = (toRoute.meta.length > 0 && toRoute.meta().title) ? toRoute.meta().title : 'B1G1 | ' + toRoute.name.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() })
})
export default routeInterceptor



// WEBPACK FOOTER //
// ./src/router/index.js